<template>
  <div class="tw-h-full tw-w-full tw-p-0 tw-m-0 tw-bg-gray-100" style="height: 50%; min-height: 200px;">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0">
        <b-tabs card fill>
          <b-tab title="TODAY" active>
            <b-card-text>
              <h6 class="tw-font-bolder tw-mb-0 text-center">Number of Subjects Referred</h6>
              <p class="text-secondary tw-text-xs text-center">Since 12:00 AM EAT</p>
              <h1
                class="tw-text-6xl tw-font-bolder text-center tw-mb-0"
              >{{ today }}</h1>
            </b-card-text>
          </b-tab>
          <b-tab title="TOTAL">
            <b-card-text>
              <h6 class="tw-font-bolder tw-mb-0 text-center">Number of Subjects Referred</h6>
              <p class="text-secondary tw-text-xs text-center">Since beginning of study</p>
              <h1
                class="tw-text-6xl tw-font-bolder text-center tw-mb-0"
              >{{ total }}</h1>
            </b-card-text>
          </b-tab>
        </b-tabs>
        
        <div class="tw-mt-auto tw-flex tw-justify-end">
          <info-popover>
            <template v-slot:title>
              Subjects Reffered
            </template>

            <h5>Tab 1: TODAY</h5>
            <p>Total number of subjects referred today.</p>
            <h5>Tab 1: TOTAL</h5>
            <p>Total number of subjects referred since the study began.</p>
          </info-popover>
        </div>
      </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

export default {
  mixins: [],
  data: function(){
            return {
                today: null,
                total: null
            }
        },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      let that = this;
      HTTP.get("/kenya/subjects_referred/get_count").then(response => {
        that.total = response.data.total;
        that.today = response.data.today;
      });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}
</style>